import { sortBy } from 'lodash';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

const selectNotifications = (state) => state.notifications.all;

export function useNotifications({ filter, sortBy: sortFunction } = {}) {
    const notifications = useSelector(selectNotifications);

    return useMemo(() => {
        let result = notifications;

        if (filter) result = result.filter(filter);
        if (sortFunction) result = sortBy(result, sortFunction);

        return result;
    }, [notifications, filter, sortFunction]);
}
